import { render } from "./ForgetPassword.vue?vue&type=template&id=1d030e83&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=1d030e83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d030e83"

export default script